export default {
    key: "municipal_interventions",
    folder: "municipalInterventions",
    basePath: "municipalinterventions",
};
